import { useCallback } from "react";

/**
 * React hook to update a specific segment in the page URL.
 * @param paramName The name of the segment to update (e.g., "tab")
 * @returns A function that, when called with a value, updates the URL accordingly.
 */
export function usePageUrl(paramName: string) {
    return useCallback(
        (newValue: string) => {
            const url = new URL(window.location.href);
            const pathSegments = url.pathname.split("/").filter(Boolean);
            // Find the index of the paramName segment
            const paramIdx = pathSegments.findIndex((seg, idx) => seg === paramName);
            if (paramIdx !== -1) {
                // If paramName exists, update its value (next segment)
                if (paramIdx + 1 < pathSegments.length) {
                    pathSegments[paramIdx + 1] = newValue;
                }
                else {
                    pathSegments.push(newValue);
                }
            }
            else {
                // If paramName doesn't exist, add paramName and value
                pathSegments.push(paramName, newValue);
            }
            url.pathname = `/${pathSegments.join("/")}`;
            window.history.replaceState(null, "", url.toString());
        },
        [paramName]
    );
}

export default usePageUrl;
